import { colorSurfaceDisabled } from '@calendly/ui/theme'

export const PackageIcon = ({ color = colorSurfaceDisabled, size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d={
        'M9.49805 1.01953C9.7802 0.90976 10.09 0.896178 10.3789 0.978516L10.501 1.01953L10.5059'
        + ' 1.02148L18.1904 4.07031L18.1992 4.07422C18.4086 4.16023 18.5906 4.29805 18.7344'
        + ' 4.47168C18.7446 4.48276 18.756 4.4931 18.7656 4.50488C18.9606 4.74413 19.07 5.04201'
        + ' 19.0752 5.35059V14.7324C19.0741 15.0126 18.9875 15.2862 18.8281 15.5166C18.6687'
        + ' 15.7471 18.4435 15.9245 18.1816 16.0244L18.1807 16.0234L10.499 18.9834L10.4951'
        + ' 18.9854C10.3615 19.036 10.2206 19.0631 10.0781 19.0713C10.0665 19.0725 10.0548'
        + ' 19.0726 10.043 19.0732C10.0296 19.0737 10.0163 19.0761 10.0029 19.0762L10.001'
        + ' 19.0752L10 19.0762C9.83925 19.0761 9.6772 19.0493 9.52246 18.9951C9.5153 18.9926'
        + ' 9.50806 18.99 9.50098 18.9873L1.81836 16.0273V16.0283C1.55528 15.9279 1.32848'
        + ' 15.7496 1.16895 15.5176C1.00947 15.2855 0.924341 15.0101 0.924805 14.7285V5.35059'
        + 'C0.929731 5.05714 1.02968 4.77386 1.20703 4.54102L1.20801 4.53906C1.20973 4.53668'
        + ' 1.21115 4.53362 1.21289 4.53125C1.21983 4.5223 1.22721 4.51368 1.23438 4.50488'
        + 'C1.23956 4.49853 1.24562 4.49248 1.25098 4.48633C1.39663 4.30446 1.58455 4.16109'
        + ' 1.80078 4.07227L1.80859 4.06836L1.87305 4.23145H1.87402L1.80957 4.06836L9.49414'
        + ' 1.02148L9.49805 1.01953ZM2.4248 14.6543L9.25 17.2832V8.63965L2.4248 6.01562'
        + 'V14.6543ZM10.75 8.63965V17.2793L17.5752 14.6504V6.01758L10.75 8.63965ZM3.74219'
        + ' 4.91504L9.99805 7.32129L14.2686 5.68066L16.2549 4.91602L9.99902 2.43457L3.74219'
        + ' 4.91504Z'
      }
      fill={color}
    />
  </svg>
)
